<div
    *cdkDragPlaceholder
    class="document-placeholder text-body-lg font-semibold"
    [qpxDropSurface]="{ state: 'valid', context: 'primary' }"
>
    Place document here
</div>
<button
    qpxButton
    matButton="outlined"
    size="sm"
    cdkDragHandle
    class="icon-only rounded-e-none!"
    [disabled]="busy()"
    [attr.aria-label]="`Drag ${document().title}`"
    qpxTooltip="Drag to another requirement"
>
    <ng-icon qpx size="sm" name="lucideGripVertical" matButtonIcon />
</button>
<qpx-quippy-pack-assigned-document
    [fileName]="document().title"
    [buildingId]="document().buildingId"
    [documentId]="document().documentId"
    [joined]="true"
    [disabled]="busy()"
/>
<button
    #assignmentButton
    qpxButton
    matButton="outlined"
    size="sm"
    [class]="
        selected()
            ? 'icon-only -ml-px rounded-none!'
            : 'icon-only -ml-px rounded-s-none!'
    "
    [disabled]="busy()"
    [attr.aria-label]="`Change assignment for ${document().title}`"
    qpxTooltip="Change assignment"
    (click)="assign($event)"
>
    <ng-icon qpx size="sm" name="lucideArrowRightLeft" matButtonIcon />
</button>
@if (selected()) {
    <button
        qpxButton
        matButton="outlined"
        size="sm"
        class="icon-only -ml-px rounded-s-none!"
        [disabled]="busy()"
        [attr.aria-label]="`Remove ${document().title}`"
        qpxTooltip="Remove document"
        (click)="remove()"
    >
        <ng-icon qpx size="sm" name="lucideX" matButtonIcon />
    </button>
}
